import { palette } from '../theme/tokens.js'

/**
 * Palette CATÉGORIELLE des graphes — une seule, pour tous.
 *
 * ⚠️ VALIDÉE au script, pas choisie à l'œil (écarts perceptifs sous
 * protanopie et deutéranopie, luminosité, saturation), en clair sur #FFFFFF
 * et en sombre sur #0F172A. Trois teintes restent sous 3:1 de contraste en
 * clair : elles ne portent donc JAMAIS l'information seules — chaque part
 * d'un anneau ou d'une jauge a sa légende chiffrée.
 *
 * ⚠️ ORDRE FIXE, jamais recyclé : la couleur suit l'entité, pas son rang. Au-delà
 * de cinq parts, la queue se replie en « Autres » (gris) plutôt que de
 * réclamer une sixième couleur.
 *
 * Le vert et le rouge du thème restent réservés aux STATUTS : un bénéfice en
 * vert se lirait comme « tout va bien ».
 */
const CLAIR = [palette.brand[500], '#eb6834', '#1baf7a', '#eda100', '#e87ba4'] as const
const SOMBRE = [palette.brand[400], '#d95926', '#199e70', '#c98500', '#d55181'] as const

export function couleursCategories(sombre: boolean): readonly string[] {
  return sombre ? SOMBRE : CLAIR
}

/** Le gris de « Autres » : présent, mais en retrait des parts nommées. */
export function couleurAutres(sombre: boolean): string {
  return sombre ? palette.neutral[500] : palette.neutral[300]
}
